<template>
  <div class="bg">
    <div class="login-container">
      <el-row>
        <el-col :span="9">
          <h3>Hello</h3>
          <h3>CallCenter</h3>
          <h5>化繁为简一呼即跟</h5>
          <h5>患者健康关注到底</h5>
        </el-col>
        <el-col :span="15">
          <div class="login-title">
            <h1>HuiDr.电话随访</h1>
          </div>
          <el-form :model="loginForm" ref="loginForm" class="login-form">
            <el-form-item>
              <input
                  type="text"
                  v-model="loginForm.username"
                  class="login-input el-input__inner"
                  placeholder="用户名"
                  maxlength="50"
                  autocomplete="on"
                  name="username"
                  id="username"
              />
            </el-form-item>
            <el-form-item>
              <input
                  type="password"
                  v-model="loginForm.password"
                  class="login-input el-input__inner"
                  placeholder="密码"
                  maxlength="50"
                  autocomplete="off"
                  name="password"
                  id="password"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                  type="submit"
                  @click="login()"
                  class="login-button el-button"
                  :loading="isLogining"
                  id="loginBtn"
              >登录
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div v-if="showAlert" class="alert-dialog">
      <div class="alert-dialog-container">
        <span>有新的版本 请按键盘组合键crtl+F5刷新页面后再进行工作</span>
      </div>
    </div>
    <el-dialog title="IP异常" :visible.sync="dialogVisible" width="40%">
      <span class="dialogTxt">{{ dialogText[UserType] }}</span>
      <div class="ipbox">
        <div class="ip">IP:{{ ip }}</div>
        <div class="ip">fig:{{ fp }}</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
            class="copy-btn"
            v-clipboard:copy="copyText"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            type="primary"
            @click="dialogVisible = false"
        >复 制</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="IP异常" :visible.sync="phoneNumberVisible" width="40%">
      <p class="validate-line">本次登录需要验证您的手机</p>
      <p class="validate-line"><span>我们将发送验证码到您的手机：{{ hideCode(loginData.phone, 3, 4) }}</span>
        <el-button :disabled="codeText != '发送验证码' && codeText != '重新获取'" @click="sendVcode" size="mini">
          {{ codeText }}
        </el-button>
      </p>
      <p class="validate-line"><span>请输入验证码</span>
        <el-input size="mini" v-model="vcode" style="width: 100px;" type="text"></el-input>
      </p>
      <div slot="footer" class="dialog-footer">
        <div>
          若遇到问题,请 <a @click="phoneNumberVisible = false; dialogVisible = true"
                           href="javascript:;">联系技术人员</a>
        </div>
        <div>
          <el-button
              @click="phoneNumberVisible = false"
          >取消
          </el-button>
          <el-button
              :loading="phoneLoginLoading"
              type="primary"
              @click="vcodeLoginHandler"
          >确定
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import {mapMutations} from "vuex";
import {
  RestAuthLogin, RestVCodeControllerSendVcode,
  RestNewFollowupCallCenterServiceUpdateSeatFollowUpPermission
} from "@src/assets/js/api.js";
import aliyunCallMixin from "@mixins/aliyunCallMixin";
import * as aliyunConfig from "@config/aliyun.config.js";
import errorHandleMixin from "@mixins/errorHandleMixin";
import axios from "axios";
import qs from "qs";
import storage from "../assets/js/storage";

const CryptoJS = require("crypto-js");
export default {
  data() {
    return {
      showAlert: false,
      phoneLoginLoading: false,
      codeSendTime: null,
      codeTime: 60,
      // timer: null,
      codeText: '发送验证码',
      vcode: "",
      loginData: {
        phone: ""
      },
      copyText: "",
      loginForm: {
        username: "",
        password: "",
      },
      phoneNumberVisible: false,
      dialogVisible: false,
      dialogText: {
        JZ: "您好，请复制以下内容并在企业微信上发送给贺怡斐。",
        QZ:
            "您好，请复制以下内容并在企业微信【工作台-审批-电话随访业务IP绑定】提交审批。",
      },
      UserType: "QZ",
      isLogining: false,
      checkSystemTimer: null,
      firstLoad: true,
      timer: {},
      fp: "",
      ip: "",
      versionSip: "0.5.0",
      versionAgentbar: "1.11.0",
      versionworkBench: "2.7.0",
    };
  },
  components: {},
  mixins: [errorHandleMixin],
  methods: {
    ...mapMutations({
      loginCommit: "login",
      callEvent: "callEvent",
      logout: "logout",
      setContactId: "setContactId",
    }),
    loadScripts() {
      const cssURL =
          "https://g.alicdn.com/cloudcallcenter/web-workbench-sdk/" +
          this.versionworkBench +
          "/main.min.css";
      const scripts = [
        "https://g.alicdn.com/cloudcallcenter/SIPml/" +
        this.versionSip +
        "/SIPml-api.js",
        "https://g.alicdn.com/cloudcallcenter-voip/web-agentbar-sdk/" +
        this.versionAgentbar +
        "/index.js",
        "https://g.alicdn.com/cloudcallcenter/web-workbench-sdk/" +
        this.versionworkBench +
        "/workbenchSdk.min.js",
      ];

      // 加载CSS
      const linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "stylesheet");
      linkTag.href = cssURL;
      const header = document.getElementsByTagName("head");
      if (header.length) {
        header[0].appendChild(linkTag);
      } else {
        document.documentElement.appendChild(linkTag);
      }

      // 加载Scripts
      scripts.forEach((item) => {
        const script = document.createElement("script");
        script.src = item;
        script.async = false; // 同步加载
        document.body.appendChild(script);
      });
    },
    // 加密函数
    encryptAES(text, key) {
      // 将密钥转换为WordArray对象
      const keyUtf8 = CryptoJS.enc.Utf8.parse(key);

      // 加密
      const encrypted = CryptoJS.AES.encrypt(text, keyUtf8, {
        mode: CryptoJS.mode.ECB, // 使用ECB模式
        padding: CryptoJS.pad.Pkcs7 // 使用PKCS7填充
      });

      // 将加密后的数据转换为Base64字符串
      return encrypted.toString();
    },
    vcodeLoginHandler() {
      let vm = this
      if (!this.vcode) {
        this.$message.error('请输入验证码')
        return
      }
      this.phoneLoginLoading = true
      this.getIp()
          .then((res) => {
            // this.phoneNumberVisible = false
            let params = {
              vcode: this.vcode,
              phone: this.loginData.phone,
              sendNumber: this.codeSendTime,
              ip: res.data.ip
            }
            this.aliyunLogin(params)
                .then((result) => {
                  if (result.status !== 0) {
                    // 测试提出来的傻屌修改
                    if (result.desc == "Bad credentials") {
                      result.desc = "请输入正确的用户名或密码";
                    }
                    if (result.desc != "ip异常") {
                      this.errorHandle(result);
                    }
                  } else {
                    if (result.retValue) {
                      this.loginCommit({
                        username: result.retValue.userName,
                        userid: result.retValue.id,
                        isCallOnly: result.retValue.isAllowAnswer,
                      });
                      // 无法立即检查 阿里云系统 ，使用定时器
                      vm.checkSystemTimer = setTimeout(() => {
                        vm.$router.replace({path: `/workTable`});
                        // vm.$router.replace({path: `/taskList`});
                      }, 0);
                      localStorage.setItem("checkSystemTimer", vm.checkSystemTimer);
                    }
                  }
                  this.isLogining = false;
                  this.phoneLoginLoading = false

                })
          })

      // .catch(() => {
      //     this.$message({
      //         type: "error",
      //         message: "登录系统错误",
      //     });
      //     this.isLogining = false;
      // });
    },
    sendVcode() {
      if (this.codeSendTime == 0) {
        this.$message.error('发送次数已达上限')
        return false
      }
      this.initCaptcha()
          .then(res => {
            var params = {
              phone: this.loginData.phone,
              equipmentIp: this.ip,
              equipmentId: (Math.random() * 10000).toFixed(0),
              ticket: res.ticket,
              randStr: res.randstr
            }
            console.log(res, params);
            this.getCodeStep2(params)
          })
    },
    getCodeStep2(params) {
      this.getVcode(params)
          .then(res => {
            if (res.status == 0) {
              this.timer = setInterval(() => {
                this.codeTime--
                this.codeText = this.codeTime
                if (this.codeTime <= 0) {
                  clearInterval(this.timer)
                  this.codeText = '重新获取'
                  this.codeTime = 60
                }
              }, 1000)
              this.codeSendTime = res.retValue
            } else {
              this.$message.error(res.desc)
              if (res.desc == "验证码错误次数：5" || res.desc == '此IP获取验证码次数已达最大限制，请联系荟医助手') {
                this.phoneNumberVisible = false
                this.dialogVisible = true
              }
            }
          })
    },

    initCaptcha() {
      return new Promise(resolve => {
        var captcha1 = new TencentCaptcha('2028247728', (res) => {
          resolve(res)
        });
        captcha1.show(); // 显示验证码
      })
    },
    hideCode(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    initFingerprintJS() {
      const fpPromise = FingerprintJS.load();
      fpPromise.then((fp) => fp.get()).then((result) => {
        console.log(result.visitorId);
        this.fp = result.visitorId;
        localStorage.setItem('fp', this.fp)
      });
    },
    onCopy() {
      this.$message({
        type: "success",
        message: "已复制到剪切板",
      });
    },
    onError() {
      this.$message({
        type: "error",
        message: "复制失败请手动复制",
      });
    },
    // 初始化 aliyun call
    initAliyunCall() {
      var vm = this;
      // aliyun register 回调
      var firstLoad = true;

      function registerSuccessHandle() {
        vm.$message({
          type: "success",
          message: "登陆云中心成功，可以进行工作了",
        });
      }

      // 数据收集起来
      function aliyunCallHandle(code, detail, error) {
        if (code === "LogOut") {
          console.log("logout4");
          var checktimeOut = localStorage.getItem("checkSystemTimer");
          checktimeOut && window.clearTimeout(checktimeOut);
          console.log("detail1", error);
          // vm.$confirm(`${detail.errorMsgTip}`, '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          // }).then(() => {
          //     vm.$router.replace('/login')
          // }).catch(() => {
          //     this.$message({
          //         type: 'info',
          //         message: '已取消'
          //     });
          // });
        } else if (code === "ErrorNotify") {
          console.log("detail", detail);
          this.loading.close()
          // vm.errorHandle({messaeg: detail && detail.errorMsgTip})
          // vm.$message.error(detail.errorMsgTip)
          vm.$confirm(`${detail.errorMsgTip}`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
              .then(() => {
                vm.$router.replace("/login");
              })
              .catch(() => {
                vm.$message({
                  type: "info",
                  message: "已取消",
                });
              });
        } else if (code === "StatusChange") {
          //第一次 空闲时 ，只能外呼
          console.log("status change ", arguments, arguments[1]);
          if (arguments[0] == 3 || arguments[1] == 3) {
            window.pubsub && window.pubsub.emit("call-applyForCallOnly");
            //window.workbench&&window.workbench.applyForCallOnly(isCallOnly);// 设置做坐席是否外呼
            firstLoad = false;
          }
          // TODO  从 0 => 1   注册中 -> 签出，给个提示
          // 因为如果耳机失效的话，这个值是可能产生，
          // 2种情况，情况1：有值从0=>1 ， 证明是未注册成功，会一直停留在登录页面，旋转
          // 情况2： 可以注册成功后，控制台报错，但是没有错误提示
          if (arguments[0] === 4) {
            // 发送一个 去休息的状态
            //window.pubsub && window.pubsub.emit('ƒ');
            window.workbench.ready();
          }
        } else if (code === "CallComing") {
          console.log("来电了... ", arguments);
          window.pubsub.emit("call-back", arguments);
        } else if (code === "CallDialing") {
          console.log("去电.... ", arguments);
          localStorage.setItem("callingPhoneNumber", arguments[1].callee);
          if (arguments[arguments.length - 1]) {
            window.pubsub.emit(
                "call-setContactId",
                arguments[arguments.length - 1]
            );
          }
        } else if (code === "CallEstablish") {
          console.log("这里是通话建立时触发的回调函数", arguments);
          window.pubsub && window.pubsub.emit("CallEstablish");
        } else if (code === "CallRelease") {
          window.pubsub.emit("call-hang-up", arguments[1]);
          window.pubsub && window.pubsub.emit("callOver");
        } else if (code === "HangUp") {
          // console.log(
          //         //dialing 对方未接听挂机 可能是坐席挂 也有可能对方自动挂 outbound 对方挂断 也有可能自己挂断
          //   "这里是通话挂断时触发的回调函数",
          //   arguments,
          //   arguments[1]
          // );
          // window.pubsub.emit("call-hang-up", arguments[1]);
          // window.pubsub && window.pubsub.emit("callOver");
        }
      }

      return new Promise((resolve, reject) => {
        console.log(window.workbench);
        if (window.workbench) {
          window.workbench = null;
        }
        let vm = this;
        // var ajaxPath=process.env.NODE_ENV === 'LOCAL'?aliyunConfig.ajaxPathDev:aliyunConfig.ajaxPath
        var ajaxPath =
            process.env.NODE_ENV != "LOCAL"
                ? aliyunConfig.ajaxPath
                : aliyunConfig.ajaxPathDev;
        var config = {
          dom: "CallCenter",
          useOpenApiSdk: false,
          instanceId: aliyunConfig.aliyunInstance,
          width: "280",
          height: "552",
          ajaxPath: ajaxPath,
          ajaxHeaders: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8;",
            "jwt": localStorage.getItem("jwt")
          },
          ajaxMethod: "post",
          afterCallRule: aliyunConfig.afterCallRule,
          header: true,
          autoAnswerCall: aliyunConfig.autoAnswerCall,
          exportErrorOfApi: true,
          moreActionList: ["mobilePhoneAnswer", "break", "offline"],
          customizedNotification: true,
          // SDK对象实例化完成时触发
          onInit: function () {
            window.workbench.register(); // 想实现自动上线在此注册
          },
          // 注册成功后
          onRegister: function (config) {
            console.log("注册成功 ... ");
            registerSuccessHandle();
            resolve(true);
          },
          onErrorNotify: function (error) {
            console.log("发生error", error);

            if (error.errorCode == '8001') {
              console.log(1111);
              vm.$alert('请检查耳机或麦克风接口是否正确插入', '提示', {
                confirmButtonText: '确定',
              });
            }

            // this.
            // aliyunCallHandle('ErrorNotify', error);
          },
          onLogOut: function (error) {
            console.log("312321", error);
            aliyunCallHandle("LogOut", ...arguments);
          },
          onLogIn: function (error) {
            aliyunCallHandle("LogIn", ...arguments, error);
          },
          // 小休时触发
          onBreak: function () {
            aliyunCallHandle("Break", ...arguments);
          },
          onReady: function () {
            aliyunCallHandle("Ready", ...arguments);
          },
          // 状态 改变 值
          onStatusChange: function (code, lastCode, context) {
            aliyunCallHandle("StatusChange", ...arguments);
          },
          // 来电时触发
          onCallComing: function (
              connid,
              caller,
              calee,
              contactId,
              skillgroupId
          ) {
            console.log("电话前状态=====》", window.workbench.getStatusCode());
            aliyunCallHandle("CallComing", {
              connid,
              caller,
              calee,
              contactId,
              skillgroupId,
            });
          },
          // 去电、拨号振铃时触发
          onCallDialing: function (connid, caller, calee, contactId) {
            console.log(
                "去电了================》",
                connid,
                caller,
                calee,
                contactId
            );
            localStorage.setItem("startTime", new Date().valueOf())
            aliyunCallHandle("CallDialing", ...arguments);
          },
          // 通话建立连接触发
          onCallEstablish: function (connid, caller, calee, contactId) {
            console.log(
                "通话建立连接触发=============>",
                connid,
                caller,
                calee,
                contactId
            );
            localStorage.setItem("contactTime", new Date().valueOf())
            aliyunCallHandle("CallEstablish", ...arguments);
          },
          // 通话结束
          onCallRelease: function (connid, caller, calee, contactId) {
            aliyunCallHandle("CallRelease", ...arguments);
          },
          // 挂机时触发
          onHangUp: function (type) {
            console.log("挂断，type=", type);
            aliyunCallHandle("HangUp", ...arguments);
          },
        };
        // 这个环境 是 developement
        if (
            process.env.NODE_ENV === "development" ||
            process.env.NODE_ENV === "production"
        ) {
          config.ajaxPath = aliyunConfig.ajaxPath;
        }
        window.workbench = new window.WorkbenchSdk(config);
        window.workbench.changeVisible(false);
        window.workbench.checkNetwork();

        if (!window.workbench) {
          reject(false);
        }
      });
    },
    login() {
      let vm = this;
      if (!this.checkUserName()) {
        return;
      } else if (!this.checkPassword()) {
        return;
      } else {
        this.isLogining = true;
        this.getIp()
            .then(res => {
              this.aliyunLogin({ip: res.data.ip})
                  .then((result) => {
                    if (result.status !== 0) {
                      if (result.status == 414) {
                        this.$router.replace('/timeOut')
                      }
                      // 测试提出来的傻屌修改
                      if (result.desc == "Bad credentials") {
                        result.desc = "请输入正确的用户名或密码";
                      }
                      if (result.desc != "ip异常") {
                        this.errorHandle(result);
                      }
                    } else {
                      if (result.retValue && result.desc != 'ip异常') {
                        this.loginCommit({
                          username: result.retValue.userName,
                          userid: result.retValue.id,
                          isCallOnly: result.retValue.isAllowAnswer,
                        });
                        this.updateSeatFollowUpPermission({
                          seatId: result.retValue.id
                        })
                        // 无法立即检查 阿里云系统 ，使用定时器
                        vm.checkSystemTimer = setTimeout(() => {
                          // vm.$router.replace({path: `/taskList`});
                          vm.$router.replace({path: `/workTable`});
                        }, 0);
                        localStorage.setItem("checkSystemTimer", vm.checkSystemTimer);
                      }
                    }
                    this.isLogining = false;
                  })
                  .catch(() => {
                    this.$message({
                      type: "error",
                      message: "登录系统错误",

                    });
                    this.isLogining = false;
                  });
            })
        // 引入 vuex

      }
    },
    checkUserName() {
      if (!(this.loginForm.username && this.loginForm.username.trim())) {
        this.$message({
          type: "error",
          message: "请输入用户名",
        });
        return false;
      }
      return true;
    },
    checkPassword() {
      if (!(this.loginForm.password && this.loginForm.password.trim())) {
        this.$message({
          type: "error",
          message: "请输入密码",
        });
        return false;
      }
      // let pattern = new RegExp("^(?![A-Za-z0-9]+$)(?![a-z0-9\\W]+$)(?![A-Za-z\\W]+$)(?![A-Z0-9\\W]+$)[a-zA-Z0-9\\W]{8,}$")
      // if(!pattern.test(this.loginForm.password)) {
      //     this.$message({
      //         type: "error",
      //         message: "密码不符合规范（大小写数字标点符号八位以上）"
      //     });
      //     return false
      // }
      return true;
    },

    keyUpEventHandle(e) {
      if (e.keyCode === 13) {
        e.preventDefault();
        document.getElementById("loginBtn").click();
      }
    },
    async getVcode(p) {
      let request = new RestVCodeControllerSendVcode()
      request.p_phone = p.phone
      request.p_equipmentIp = p.equipmentIp
      request.p_equipmentId = p.equipmentId
      request.p_ticket = p.ticket
      request.p_randStr = p.randStr
      await request.send()
      return request.result
    },
    async updateSeatFollowUpPermission(p) {
      let request = new RestNewFollowupCallCenterServiceUpdateSeatFollowUpPermission()
      request.p_seatId = p.seatId
      await request.send()
      return request.result
    },
    // 用户登录
    async aliyunLogin(p = {}) {
      var authlogin = new RestAuthLogin();
      authlogin.p_username = this.encryptAES(this.loginForm.username,'huiyicallcenter0');
      authlogin.p_password = this.encryptAES(this.loginForm.password,'huiyicallcenter0');
      authlogin.p_inIp = this.fp;
      authlogin.p_outIp = p.ip;
      authlogin.p_code = p.vcode || null
      authlogin.p_phone = p.phone || null
      authlogin.p_sendNumber = p.sendNumber || null
      authlogin.url = "/auth/login";
      await authlogin.send();
      if (authlogin.result && authlogin.result.status === 0 && authlogin.result.desc !== 'ip异常') {
        localStorage.setItem('jwt', authlogin.result.retValue.jwt)
        //1 阿里云 2 华为云
        localStorage.setItem('seatType', authlogin.result.retValue.seatType)
        if(authlogin.result.retValue.seatType == 1) {
          this.loadScripts()
        }
        return authlogin.result;
        // var result = await this.initAliyunCall();
        // if (result) {
        //   this.clearInter();
        //   return authlogin.result;
        // } else {
        //   return {
        //     messaeg: "登录云呼叫系统错误",
        //     status: -99,
        //   };
        // } x
      } else {
        this.$message.error(authlogin.result);
        if (authlogin.result.desc == "ip异常" || authlogin.result.desc.indexOf('上限') != -1) {
          if (!authlogin.result.retValue.isAuto || !authlogin.result.retValue.phone) {
            this.dialogVisible = true;
          } else {
            this.loginData = authlogin.result.retValue
            this.phoneNumberVisible = true
          }
          if (this.loginForm.username.indexOf("uber") != -1) {
            this.UserType = "JZ";
          } else {
            this.UserType = "QZ";
          }
          this.copyText = "ip:" + this.ip + "\nfig:" + this.fp;
        }
        return authlogin.result;
      }
    },
    clearInter() {
      let vm = this;
      clearInterval(vm.timer);
      vm.createInter();
    },
    async getIp() {
      if (localStorage.getItem('ip')) {
        return {
          data: {
            ip: localStorage.getItem('ip')
          }
        }
      } else {
        let res = await axios.get('https://manager.test.huidr.com/api/ipService/getClientIP')
        this.ip = res.data.retValue
        localStorage.setItem('ip', res.data.retValue)
        return {
          data: {
            ip: res.data.retValue
          }
        }
      }
    },
    createInter() {
      let vm = this;
      this.timer = setInterval(() => {
        var str = "";
        for (var i = 0; i < 7; i += 1) {
          str += Math.floor(Math.random() * 10);
        }
        var Myhttp = axios.create({
          headers: {
            "Content-Type":
                "application/x-www-form-urlencoded;charset=utf-8;boundary =" +
                str,
          },
        });
        let data = {
          request: {instanceId: `${aliyunConfig.aliyunInstance}`},
        };
        Myhttp.post(
            aliyunConfig.ajaxPath + "?action=RefreshToken",
            qs.stringify({
              request: JSON.stringify({
                instanceId: `${aliyunConfig.aliyunInstance}`,
              }),
            })
        )
            .then(function (res) {
              console.log("手动刷新success path:login/318==>", res);
            })
            .catch(function (err) {
              clearInterval(vm.timer);
              console.log("手动刷新error path:login/318===>", err);
            });
      }, 20 * 60 * 1000);
    },
    clearMemoryCache() {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'data:text/css;charset=UTF-8,'; // 添加一个空的CSS链接
      document.head.appendChild(link);
      document.head.removeChild(link);
    },
    showAlertDialog() {
      this.showAlert = true
    },
    checkVersion() {
      var ctrlF5Event = new KeyboardEvent('keydown', {
        key: 'F5',
        code: 'F5',
        ctrlKey: true,
        shiftKey: false,
        altKey: false,
        metaKey: false
      });
      let pkjs = require('../../package.json')
      const version = pkjs.version
      console.log(version);
      axios.get('https://app.huidr.com/callcenterExe/test-bucket/version.json')
          .then(res => {
            let currentVersion = process.env.NODE_ENV != 'production' ? res.data.versionTest : res.data.version
            console.log(currentVersion);
            if (version != currentVersion) {
              this.showAlertDialog()
              // this.$message.info('正在更新新版本请稍后......')
              // document.dispatchEvent(ctrlF5Event);
              // location.reload(true)
            }
          })
    }
  },
  mounted() {
    this.getIp()
        .then(res => {
        })
    this.checkVersion()
    this.$refs["loginForm"].$el.removeEventListener(
        "keyup",
        this.keyUpEventHandle
    );
    this.$refs["loginForm"].$el.addEventListener(
        "keyup",
        this.keyUpEventHandle
    );
    window.pubsub &&
    window.pubsub.off("logout").on("logout", function () {
      //setTimeout(()=>{window.location.href = '/login';},0)
      console.log("logout3");
      window.requestAnimationFrame(() => {
        window.location.href = "/login";
      });
    });
    this.initFingerprintJS();

  },
  destroyed() {
    // clearInterval(this.timer)
  },
};
</script>

<style scoped lang="scss">
.alert-dialog {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.3);
  .alert-dialog-container {
    background-color: #fff;
    width: 30%;
    text-align: center;
    border-radius: 5px;
    padding: 10px;
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.validate-line {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 10px;

  span {
    margin-right: 15px;
  }
}

.bg {
  width: 100%;
  height: 100vh;
  background-image: url("./image/bg.png");
  display: flex;
  justify-content: center;
  align-items: center;
  background-position: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.login-container {
  width: 600px;
  height: 400px;
  border: 1px solid rgb(62, 185, 253);
  margin: 15vh auto;
  background-color: white;

  & > .el-row {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    & > .el-col:nth-of-type(1) {
      background: linear-gradient(rgb(62, 185, 253), rgb(50, 164, 253));
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      color: rgb(255, 255, 255);
      padding-top: 93px;
      padding-left: 30px;

      & > h3 {
        margin-bottom: 23px;
      }

      & > h5:nth-last-of-type(1) {
        margin-top: 12px;
      }
    }

    & > .el-col:nth-last-of-type(1) {
      background: rgb(255, 255, 255);
    }

    &:nth-last-of-type(1) {
      width: 100%;
    }
  }

  h3 {
    font-size: 32px;
  }

  h5 {
    font-size: 14px;
  }

  h1 {
    font-size: 22px;
    color: rgb(75, 156, 249);
  }

  .login-title {
    padding-left: 10%;
    margin-bottom: 69px;
    text-align: left;
  }

  .login-form {
    width: 80%;
    margin-left: 10%;

    .login-input {
      .el-input__inner {
        border: none;
        // border-bottom: 1px solid blue;
        padding: 0;
        border-radius: 0;
      }
    }

    .login-button {
      width: 224px;
      background-color: rgb(243, 159, 51);
      color: rgb(255, 255, 255);
      font-size: 20px;
      border: none;
      box-shadow: 0px 2px 1px 0px rgb(166, 167, 168);
    }
  }
}

.dialogTxt {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 10px;
}

.ip {
  height: 25px;
  color: #000;
  font-size: 14px;
  line-height: 25px;
}

.ipbox {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px;
  height: 70px;
}
</style>
